<script lang="ts">
  import {fly} from 'svelte/transition';
  import {onMount} from 'svelte';
  import {
    personalInfo,
    deal,
    recaptcha,
    Step,
    currentStep,
    apiUrl,
  } from 'Store/InvestorFlowStore';
  import AmountSelection from 'Components/InvestorFlow/v2/Components/LeftContainer/AmountSelection.svelte';
  import RecaptchaV3 from 'Components/Common/RecaptchaV3.svelte';
  import PersonalInfo from 'Components/InvestorFlow/v2/Components/LeftContainer/PersonalInfo.svelte';
  import IncentiveTierCodesForm from 'Components/InvestorFlow/v2/Components/LeftContainer/IncentiveTierCodesForm.svelte';
  import {startExperiment} from 'Utility/investorFlow/investorFlowAPI';
  import {incentivePlans} from 'Store/deals/incentivePlan';

  // fix for multiple embedded checkouts rendered under different "tabs"
  currentStep.set(Step.PERSONAL_INFO);

  let customInvestmentAmount = $personalInfo.investment_amount;

  $: showRecaptcha =
    $recaptcha.sitekey && $recaptcha.sitekey_v3 && $recaptcha.render;

  const reCaptchaWidth = 304;
  let personalContainer: HTMLElement;
  let recaptchaBox: HTMLElement;
  let recaptchaInstance: RecaptchaV3;

  const scaleRecaptcha = new ResizeObserver(entries => {
    // Recaptcha iframe width is 304px by default with regular options setup
    const rect = entries[0].contentRect;

    // Exclude viewports when input's width is dynamic with screen size.
    // 415px limit need to be included as a limit for not having undesired oversized re-captcha iframe
    if (!(window.innerWidth >= 415 && window.innerWidth <= 767)) {
      const recaptchaScale = rect.width / reCaptchaWidth;
      if (recaptchaBox) {
        recaptchaBox.style.transform = `scale(${recaptchaScale})`;
      }
    }
  });

  const refreshRecaptcha = async () => {
    if (recaptchaInstance) {
      await recaptchaInstance.refreshV3();
    }
  };

  onMount(async () => {
    scaleRecaptcha.observe(personalContainer);
    await startExperiment();
  });
</script>

{#if $currentStep === Step.PERSONAL_INFO}
  <PersonalInfo
    bind:formContainer={personalContainer}
    onSubmit={refreshRecaptcha}
  >
    <div slot="recaptcha">
      {#if showRecaptcha}
        <RecaptchaV3
          bind:this={recaptchaInstance}
          bind:recaptchaV2Box={recaptchaBox}
          baseUrl={$apiUrl}
          recaptchaSiteKey={$recaptcha.sitekey}
          invisibleRecaptchaSiteKey={$recaptcha.sitekey_v3}
        />
      {/if}
    </div>
  </PersonalInfo>
{:else if $currentStep === Step.INVESTMENT_AMOUNT}
  <div class="centered" in:fly={{x: 300, duration: 150}}>
    <AmountSelection
      minimum_investment={$deal.minimum_investment}
      maximum_investment={$deal.maximum_investment}
      price_per_security={$incentivePlans.final_price.amount_cents}
      currency={$deal.currency}
      bind:customInvestmentAmount
    />
  </div>
{:else if $currentStep === Step.INCENTIVE_TIER}
  <div class="centered" in:fly={{x: 300, duration: 150}}>
    <IncentiveTierCodesForm />
  </div>
{/if}
